<div class="wrapper flex vcenter">
  <div
    class="outter-box"
    role="checkbox"
    tabindex="0"
    [attr.aria-checked]="checked"
    [class.toggled-on]="checked"
    (click)="onCheck()"
    (keydown.enter)="onCheck()"
    (keydown.space)="onCheck(); $event.preventDefault()"
  >
    @if (checked) {
      <div class="inner-box"></div>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
